/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_4Inputs */

const en_cp_give_4 = /** @type {(inputs: Cp_Give_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office hours and an end-of-semester report (Class & Campus Partner)`)
};

const id_cp_give_4 = /** @type {(inputs: Cp_Give_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office hours dan laporan akhir per semester (Kelas & Kampus Mitra)`)
};

/**
* | output |
* | --- |
* | "Office hours and an end-of-semester report (Class & Campus Partner)" |
*
* @param {Cp_Give_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_4 = /** @type {((inputs?: Cp_Give_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_4(inputs)
	return en_cp_give_4(inputs)
});